/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Image Based Subtitle Export" |
*
* @param {Image_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_title = /** @type {((inputs?: Image_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation de sous-titres en images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildbasierter Untertitelexport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione di sottotitoli basati su immagini")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт субтитров на основе изображений")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación de subtítulos basada en imágenes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("基于图像的字幕导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画像ベースの字幕エクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छवि आधारित उपशीर्षक निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação de legendas baseadas em imagens")
	return /** @type {LocalizedString} */ ("Image Based Subtitle Export")
});